export const navLinks = [
  {
    id: "about",
    title: "About",
  },
  {
    id: "work",
    title: "Work",
  },
  {
    id: "contact",
    title: "Contact",
  },
];

const services = [
  {
    title: "Custom Software Development",
    description:"Develop tailored software solutions to meet specific client needs, such as web applications, mobile apps, enterprise software, or desktop applications.",
    icon: '',
  },
  {
    title: "Web Development",
    description:"Build responsive and interactive websites using modern web technologies, frameworks, and content management systems.",
    icon: 'mobile',
  },
  {
    title: "Mobile App Development",
    description:"Create mobile applications for iOS and Android platforms, ranging from native apps to cross-platform or hybrid solutions.",
    icon: 'mobile',
  },
  {
    title: "Product Prototyping ",
    description:"Assist clients in developing minimum viable products (MVPs) and prototypes to validate their ideas, gather user feedback, and attract potential investors.",
    icon: 'backend',
  },
  {
    title: "E-commerce Development",
    description:"Develop online stores and e-commerce platforms, integrating payment gateways, inventory management systems, and other essential features to facilitate online transactions.",
    icon: 'creator',
    visibility:"md:hidden"
  },
   {
    title: "Software consultancy",
    description:"Provide clients with expert guidance and consultancy services on various aspects of software development and technology implementation.",
    icon: 'web',
  },
  {
    title: "Maintenance and Support",
    description:"Offer ongoing software maintenance, bug fixing, feature enhancements, and technical support services to ensure smooth operation and user satisfaction",
    icon: 'web',
  },
];

const Faqs = [
  {
    question: "What services do you offer?",
    answer:
      "We provide a comprehensive range of services including architectural design, construction management, real estate development, and interior planning. Our team ensures end-to-end project delivery tailored to your needs.",
    icon: 'building',
  },
  {
    question: "How long does a typical construction project take?",
    answer:
      "The timeline depends on the scale and complexity of the project. Residential buildings may take 6–12 months, while commercial or mixed-use developments can take longer. We provide a detailed timeline after project assessment.",
    icon: 'clock',
  },
  {
    question: "Do you help with permits and regulatory approvals?",
    answer:
      "Yes, we handle all necessary building permits, zoning approvals, and regulatory documentation on your behalf to ensure a smooth project flow and compliance with local laws.",
    icon: 'file-alt',
    visibility: "md:hidden",
  },
  {
    question: "Can you work with my existing land or property?",
    answer:
      "Absolutely. Whether you're looking to renovate, expand, or build on existing land, our team will assess the site conditions and provide design and construction solutions tailored to your property.",
    icon: 'home',
    visibility: "md:hidden",
  },
  {
    question: "What makes your firm different from others?",
    answer:
      "Our strength lies in combining innovative design with practical construction expertise. We focus on transparency, quality, and long-term value in every project — whether it's a home, office, or multi-use property.",
    icon: 'star',
    visibility: "md:hidden",
  }
];


const technologies = [
  {
    name: "HTML 5",
    icon: 'html',
  },
  {
    name: "CSS 3",
    icon: 'css',
  },
  {
    name: "JavaScript",
    icon: 'javascript',
  },
  {
    name: "TypeScript",
    icon: 'typescript',
  },
  {
    name: "React JS",
    icon: 'reactjs',
  },
  {
    name: "Redux Toolkit",
    icon: 'redux',
  },
  {
    name: "Tailwind CSS",
    icon: 'tailwind',
  },
  {
    name: "Node JS",
    icon: 'nodejs',
  },
  {
    name: "MongoDB",
    icon: 'mongodb',
  },
  {
    name: "Three JS",
    icon: 'threejs',
  },
  {
    name: "git",
    icon: 'git',
  },
  {
    name: "figma",
    icon: 'figma',
  },
  {
    name: "docker",
    icon: 'docker',
  },
];

const experiences = [
  {
    title: "React.js Developer",
    company_name: "Starbucks",
    icon: 'starbucks',
    iconBg: "#383E56",
    date: "March 2020 - April 2021",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
      "Implementing responsive design and ensuring cross-browser compatibility.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
  {
    title: "React Native Developer",
    company_name: "Tesla",
    icon: 'tesla',
    iconBg: "#E6DEDD",
    date: "Jan 2021 - Feb 2022",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
      "Implementing responsive design and ensuring cross-browser compatibility.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
  {
    title: "Web Developer",
    company_name: "Shopify",
    icon: 'shopify',
    iconBg: "#383E56",
    date: "Jan 2022 - Jan 2023",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
      "Implementing responsive design and ensuring cross-browser compatibility.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
  {
    title: "Full stack Developer",
    company_name: "Meta",
    icon: 'meta',
    iconBg: "#E6DEDD",
    date: "Jan 2023 - Present",
    points: [
      "Developing and maintaining web applications using React.js and other related technologies.",
      "Collaborating with cross-functional teams including designers, product managers, and other developers to create high-quality products.",
      "Implementing responsive design and ensuring cross-browser compatibility.",
      "Participating in code reviews and providing constructive feedback to other developers.",
    ],
  },
];

const testimonials = [
  {
    testimonial:
      "Edges Design transformed our vision into a breathtaking architectural masterpiece. Their attention to detail and professionalism is unmatched.",
    name: "Alice Niyonsaba",
    designation: "Managing Director",
    company: "Prime Estates Ltd",
    image: "https://randomuser.me/api/portraits/women/68.jpg",
  },
  {
    testimonial:
      "From concept to completion, Edges delivered beyond expectations. Their structural expertise gave us confidence at every stage.",
    name: "Samuel Karekezi",
    designation: "Project Manager",
    company: "CityBuild Contractors",
    image: "https://randomuser.me/api/portraits/men/60.jpg",
  },
  {
    testimonial:
      "What impressed me most was their ability to blend modern design with functionality. Our commercial complex now stands out in the city skyline.",
    name: "Christine Uwase",
    designation: "Real Estate Developer",
    company: "Vista Holdings",
    image: "https://randomuser.me/api/portraits/women/41.jpg",
  },
  {
    testimonial:
      "Edges Design made the process smooth and stress-free. Their team was responsive, creative, and deeply committed to quality delivery.",
    name: "Emmanuel Habiyambere",
    designation: "Founder",
    company: "Habiyambere Construction Co.",
    image: "https://randomuser.me/api/portraits/men/35.jpg",
  },
];

const projects = [
  {
    name: "Car Rent",
    description:
      "Web-based platform that allows users to search, book, and manage car rentals from various providers, providing a convenient and efficient solution for transportation needs.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "mongodb",
        color: "green-text-gradient",
      },
      {
        name: "tailwind",
        color: "pink-text-gradient",
      },
    ],
    image: 'carrent',
    source_code_link: "https://github.com/",
  },
  {
    name: "Job IT",
    description:
      "Web application that enables users to search for job openings, view estimated salary ranges for positions, and locate available jobs based on their current location.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "restapi",
        color: "green-text-gradient",
      },
      {
        name: "scss",
        color: "pink-text-gradient",
      },
    ],
    image: 'jobit',
    source_code_link: "https://github.com/",
  },
  {
    name: "Trip Guide",
    description:
      "A comprehensive travel booking platform that allows users to book flights, hotels, and rental cars, and offers curated recommendations for popular destinations.",
    tags: [
      {
        name: "nextjs",
        color: "blue-text-gradient",
      },
      {
        name: "supabase",
        color: "green-text-gradient",
      },
      {
        name: "css",
        color: "pink-text-gradient",
      },
    ],
    image: '',
    source_code_link: "https://github.com/",
  },
];

export { services, technologies, experiences, testimonials,Faqs, projects };
